<mat-form-field
    [appearance]="'outline'"
    [attr.data-testid]="id()"
    class="iq-autocomplete"
    (keydown.enter)="submitted()"
>
    <mat-label>{{ label() }}</mat-label>
    <mat-chip-grid
        #chipGrid
        aria-label="locations"
        [attr.data-uitype]="'chip-group'"
    >
        @for (geoSuggestion of suggestions; track idx; let idx = $index) {
        <mat-chip-row
            #chip
            [attr.data-uiType]="'chip'"
            (removed)="remove()"
            (keypress)="chip.remove()"
        >
            {{ geoSuggestion?.displayName }}
            <button
                matChipRemove
                class="font-body-2"
                [attr.aria-label]="'remove ' + geoSuggestion.pointId"
                [attr.data-testid]="id() + '-chip'"
                [attr.data-styleTarget]="id() + '-chip'"
                [attr.data-uitype]="'chip'"
            >
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
        </mat-chip-row>
        }
    </mat-chip-grid>
    <input
        #queryEle
        class="w-full"
        [formControl]="queryCtrl"
        [matChipInputFor]="chipGrid"
        [matAutocomplete]="auto"
        [placeholder]="placeholder()"
        [attr.data-testid]="id() + '-input'"
        [attr.data-styleTarget]="id() + '-input'"
        [attr.data-uitype]="'text-input'"
        (keydown.tab)="onTab()"
        (focus)="focused.emit()"
    />
    <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="
            geoSuggestions()?.length > 0 ? selected($event) : null
        "
        autoActiveFirstOption
    >
        @if (searchPending) {
        <mat-option
            [attr.data-testid]="id() + '-option-loading'"
            [attr.data-styleTarget]="id() + '-option-loading'"
            [attr.data-uitype]="'option'"
            class="animate-pulse !bg-dat-grey-200 space-x-4 items-center w-full h-full"
        ></mat-option>
        } @else if (query()?.length >= 3 && geoSuggestions()?.length <= 0) {
        <mat-option
            [attr.data-testid]="id() + '-option-no-result'"
            [attr.data-styleTarget]="id() + '-option-no-result'"
            [attr.data-uitype]="'option'"
        >
            No Locations Found
        </mat-option>
        } @else { @for (geoSuggestion of (geoSuggestions()) ; track idx; let idx
        = $index) {
        <mat-option
            [attr.data-testid]="id() + '-option-' + geoSuggestion.displayName"
            [attr.data-styleTarget]="
                id() + '-option-' + geoSuggestion.displayName
            "
            [attr.data-uitype]="'option'"
            [value]="geoSuggestion"
        >
            {{ geoSuggestion.displayName }}
        </mat-option>
        } }
    </mat-autocomplete>
    <mat-error *ngIf="inputControl?.errors?.required" class="datiq-autocomplete__error">
        {{
            customErrorMessage()?.length
                ? customErrorMessage()
                : getErrorMessage()
        }}
    </mat-error>
    <mat-error *ngIf="inputControl?.errors?.locationError" class="datiq-autocomplete__error">
        {{
            locationErrorMessage()?.length
                ? locationErrorMessage()
                : getErrorMessage()
        }}
    </mat-error>
</mat-form-field>
